// Функции для перемещения контейнеров
export function useContainerActions({
  setContainers, setDocContainers, setHomeworkContainers, setEditorContents,
}) {
  const moveContainerUp = (id) => {
    setContainers(prev => {
      const currentIndex = prev.findIndex(c => c.id === id);
      if (currentIndex > 0) {
        const newContainers = [...prev];
        [newContainers[currentIndex], newContainers[currentIndex - 1]] =
        [newContainers[currentIndex - 1], newContainers[currentIndex]];
        return newContainers;
      }
      return prev;
    });
  };

  const moveContainerDown = (id) => {
    setContainers(prev => {
      const currentIndex = prev.findIndex(c => c.id === id);
      if (currentIndex < prev.length - 1) {
        const newContainers = [...prev];
        [newContainers[currentIndex], newContainers[currentIndex + 1]] =
        [newContainers[currentIndex + 1], newContainers[currentIndex]];
        return newContainers;
      }
      return prev;
    });
  };

  const moveDocContainerUp = (docId, containerId) => {
    setDocContainers(prev => {
      const docContainersList = prev[docId] || [];
      const currentIndex = docContainersList.findIndex(c => c.id === containerId);
      if (currentIndex > 0) {
        const newContainers = [...docContainersList];
        [newContainers[currentIndex], newContainers[currentIndex - 1]] =
        [newContainers[currentIndex - 1], newContainers[currentIndex]];
        return { ...prev, [docId]: newContainers };
      }
      return prev;
    });
  };

  const moveDocContainerDown = (docId, containerId) => {
    setDocContainers(prev => {
      const docContainersList = prev[docId] || [];
      const currentIndex = docContainersList.findIndex(c => c.id === containerId);
      if (currentIndex < docContainersList.length - 1) {
        const newContainers = [...docContainersList];
        [newContainers[currentIndex], newContainers[currentIndex + 1]] =
        [newContainers[currentIndex + 1], newContainers[currentIndex]];
        return { ...prev, [docId]: newContainers };
      }
      return prev;
    });
  };

  const addContainer = () => {
    const newId = Date.now(); // Используем timestamp для уникального ID
    setContainers(prev => [...prev, { id: newId, type: 'editor' }]);
  };

  const addDocContainer = (docId) => {
    const newId = Date.now(); // Используем timestamp для уникального ID
    setDocContainers(prev => {
      const newContainers = {
        ...prev,
        [docId]: [...(prev[docId] || []), { id: newId, type: 'editor' }]
      };
      return newContainers;
    });
  };

  const deleteContainer = (id) => {
    setContainers(prev => prev.filter(container => container.id !== id));
  };

  const deleteDocContainer = (docId, containerId) => {
    setDocContainers(prev => ({
      ...prev,
      [docId]: (prev[docId] || []).filter(container => container.id !== containerId)
    }));
  };

  const addHomeworkContainer = (homeworkId) => {
    const newId = Date.now(); // Используем timestamp для уникального ID

    setHomeworkContainers(prev => {
      const newContainers = {
        ...prev,
        [homeworkId]: [...(prev[homeworkId] || []), { id: newId, type: 'editor' }]
      };
      return newContainers;
    });

    // Контейнер добавлен в состояние, сохранение в Supabase произойдет при отправке homework
  };

  const deleteHomeworkContainer = (homeworkId, containerId) => {
    setHomeworkContainers(prev => ({
      ...prev,
      [homeworkId]: (prev[homeworkId] || []).filter(container => container.id !== containerId)
    }));

    // Контейнер удален из состояния, сохранение в Supabase произойдет при отправке homework

    // Удаляем из editorContents
    const key = `homework-${homeworkId}-container-${containerId}`;
    setEditorContents(prev => {
      const newContents = { ...prev };
      delete newContents[key];
      return newContents;
    });
  };

  const moveHomeworkContainerUp = (homeworkId, containerId) => {
    setHomeworkContainers(prev => {
      const homeworkContainersList = prev[homeworkId] || [];
      const currentIndex = homeworkContainersList.findIndex(c => c.id === containerId);
      if (currentIndex > 0) {
        const newContainers = [...homeworkContainersList];
        [newContainers[currentIndex], newContainers[currentIndex - 1]] =
        [newContainers[currentIndex - 1], newContainers[currentIndex]];
        return { ...prev, [homeworkId]: newContainers };
      }
      return prev;
    });
  };

  const moveHomeworkContainerDown = (homeworkId, containerId) => {
    setHomeworkContainers(prev => {
      const homeworkContainersList = prev[homeworkId] || [];
      const currentIndex = homeworkContainersList.findIndex(c => c.id === containerId);
      if (currentIndex < homeworkContainersList.length - 1) {
        const newContainers = [...homeworkContainersList];
        [newContainers[currentIndex], newContainers[currentIndex + 1]] =
        [newContainers[currentIndex + 1], newContainers[currentIndex]];
        return { ...prev, [homeworkId]: newContainers };
      }
      return prev;
    });
  };

  return {
    moveContainerUp, moveContainerDown,
    moveDocContainerUp, moveDocContainerDown,
    addContainer, addDocContainer,
    deleteContainer, deleteDocContainer,
    addHomeworkContainer, deleteHomeworkContainer,
    moveHomeworkContainerUp, moveHomeworkContainerDown,
  };
}
